import { lazy } from 'react';
import { authRoles } from 'app/auth';

const OrdersListView = lazy(() => import('./use-cases/OrdersListView'));
const OrderView = lazy(() => import('./use-cases/OrderView'));

const OrdersConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'orders',
      element: <OrdersListView />,
    },
    {
      path: 'orders/:orderId',
      element: <OrderView />,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: false,
            },
          },
        },
      },
    },
  ],
};

export default OrdersConfig;
